import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-6c86f8a7"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "LocationPermissionsNeeded"
};
var _hoisted_2 = {
  "class": "modal"
};
var _hoisted_3 = {
  key: 0,
  "class": "modal-content"
};
var _hoisted_4 = {
  key: 1,
  "class": "encouragement"
};
var _hoisted_5 = {
  key: 2,
  "class": "modal-summary"
};
var _hoisted_6 = {
  key: 3,
  "class": "modal-summary modal-summary--blue"
};
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("u", null, "Read the Story", -1);
});
var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: "assets/web/carousels/camera_permissions/camera.png",
    alt: "Feedback",
    "class": "modal-image"
  }, null, -1);
});
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    "class": "encouragement"
  }, "Enable Camera Permissions", -1);
});
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    "class": "smalltext"
  }, "This only enables camera when you use the video or camera features. We do not have access to your camera at any other times other than to enable and use those features.", -1);
});
var _hoisted_11 = {
  key: 1,
  "class": "modal-content"
};
var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    "class": "encouragement"
  }, "Done!", -1);
});
var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    "class": "modal-summary"
  }, " You may now close the window to continue. ", -1);
});
var _hoisted_14 = {
  key: 2,
  "class": "modal-content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  var _component_ImageCarousel = _resolveComponent("ImageCarousel");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_Transition, {
    name: "fade"
  }, {
    "default": _withCtx(function () {
      return [_createElementVNode("div", _hoisted_2, [_ctx.permissionGranted === false && _ctx.$store.state.permission_camera != 'denied' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [!_ctx.success ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
        key: 0,
        icon: "times",
        "class": "close-icon",
        onClick: _ctx.closeModal
      }, null, 8, ["onClick"])) : _createCommentVNode("", true), !_ctx.success ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Enable Camera Permissions")) : _createCommentVNode("", true), !_ctx.handleLowerScores && !_ctx.success ? (_openBlock(), _createElementBlock("p", _hoisted_5, " In order to use the camera or video features, you must first enable camera permissions. ")) : _createCommentVNode("", true), !_ctx.handleLowerScores && !_ctx.success ? (_openBlock(), _createElementBlock("p", _hoisted_6, [_createTextVNode(" Did you know this app was made by one person over the last 16 months? "), _hoisted_7])) : _createCommentVNode("", true), _hoisted_8, _createElementVNode("div", null, [_hoisted_9, _hoisted_10, _createElementVNode("button", {
        "class": "review-button",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          _ctx.$store.dispatch('requestCameraPermission');
        })
      }, " Enable Camera ")])])) : _createCommentVNode("", true), _ctx.permissionGranted === true ? (_openBlock(), _createElementBlock("div", _hoisted_11, [!_ctx.success ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
        key: 0,
        icon: "times",
        "class": "close-icon",
        onClick: _ctx.closeModal
      }, null, 8, ["onClick"])) : _createCommentVNode("", true), _createElementVNode("div", null, [_hoisted_12, _hoisted_13, _createElementVNode("button", {
        "class": "review-button",
        onClick: _cache[1] || (_cache[1] = function () {
          return _ctx.closeModal && _ctx.closeModal.apply(_ctx, arguments);
        })
      }, " Close Window ")])])) : _createCommentVNode("", true), _ctx.$store.state.permission_camera == 'denied' ? (_openBlock(), _createElementBlock("div", _hoisted_14, [!_ctx.success ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
        key: 0,
        icon: "times",
        "class": "close-icon",
        onClick: _ctx.closeModal
      }, null, 8, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_ImageCarousel, {
        items: _ctx.deniedPermissionsWalkthoughAndroid
      }, null, 8, ["items"])])) : _createCommentVNode("", true)])];
    }),
    _: 1
  })]);
}